<template>
  <fragment>
    <slot name="temp" :src="parsedUrl" />
  </fragment>
</template>
<script>
import { parseGcsUrl } from '../../utils/url';
export default {
  props: {
    src: String
  },
  computed: {
    parsedUrl() {
      return parseGcsUrl(this.src);
    }
  }
};
</script>
